import { Text } from 'ink';
import BuildError from '../../../components/BuildError';
import ErrorDisplay from '../../../components/ErrorDisplay';
import LoadingText from '../../../components/LoadingText';
import { ReleaseBuildState } from '../utilities/types';

export default function ReleaseBuildView({
  commandUsed,
  state,
}: {
  commandUsed?: string;
  state: ReleaseBuildState;
}) {
  switch (state.state) {
    case 'build-error': {
      return (
        <BuildError
          build={state.build}
          description="Can't release build"
          message={state.error?.message || 'Internal build error'}
        />
      );
    }

    case 'complete':
      return (
        <Text bold color="greenBright">
          Released!
        </Text>
      );

    case 'error':
      return <ErrorDisplay commandUsed={commandUsed} error={state.error} />;

    case 'loading':
      return <LoadingText />;

    case 'releasing':
      return <LoadingText text="Releasing" />;

    default:
      return (
        <ErrorDisplay
          commandUsed={commandUsed}
          error={new Error(`Unknown state ${state}`)}
        />
      );
  }
}
